import { defineComponent as _defineComponent } from 'vue'
import { LicenseFeature } from '@/modules/shared/types';
import MissingLicenseDlg from '@/modules/shared/components/dialogs/generic/MissingLicenseDlg.vue';
import { Port } from '@/modules/shared/Port';
import { ref } from 'vue';
import store from '@/store/store';

type Props = {
    requiredFeatures?: LicenseFeature[];
    anyFeatures?: LicenseFeature[];
}

type Emits = {
    (event: 'click', payload: any): void;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'LicenseGuard',
  props: {
    requiredFeatures: null,
    anyFeatures: null
  },
  emits: ["click"],
  setup(__props: any, { emit: emits }: { emit: ({
    (event: 'click', payload: any): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
    requiredFeatures?: LicenseFeature[];
    anyFeatures?: LicenseFeature[];
};



const showInfoDlg = ref(false);

async function hasAllRequiredFeatureLicenses(): Promise<boolean> {
    if (await Port.auth.isAppAdmin()) return true;
    if (!props.requiredFeatures || props.requiredFeatures.length === 0) return true;

    return store.getters['User/hasAllFeatureLicenses'](props.requiredFeatures);
}

async function hasAnyOfAnyFeatureLicenses(): Promise<boolean> {
    if (await Port.auth.isAppAdmin()) return true;
    if (!props.anyFeatures || props.anyFeatures.length === 0) return true;

    return store.getters['User/hasAnyFeatureLicense'](props.anyFeatures);
}

async function isValid(): Promise<boolean> {
    return (await hasAllRequiredFeatureLicenses()) && (await hasAnyOfAnyFeatureLicenses());
}

async function onClick(event: any) {
    if (await isValid()) {
        emits('click', event);
    } else {
        showInfoDlg.value = true;
    }
}

return { __sfc: true,props, emits, showInfoDlg, hasAllRequiredFeatureLicenses, hasAnyOfAnyFeatureLicenses, isValid, onClick, MissingLicenseDlg }
}

})